import React, { useState } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Zap, CheckCircle, Clock, Loader2 } from 'lucide-react';

export const AutoProcessNode: React.FC<{ data: { label: string; color: string; demoState?: { status: 'waiting' | 'processing' | 'complete' } } }> = ({ data }) => {
  const [internalStatus] = useState<'waiting' | 'processing' | 'complete'>('waiting');
  const status = data.demoState?.status || internalStatus;

  return (
    <div className="bg-card border rounded-xl shadow-md w-[280px] overflow-hidden">
      <div
        className="px-3 py-2 text-xs font-semibold text-white flex items-center gap-1.5"
        style={{ background: data.color }}
      >
        <Zap className="h-3.5 w-3.5" />
        {data.label}
      </div>

      <div className="p-3">
        {status === 'waiting' && (
          <div className="flex items-center gap-2 text-muted-foreground">
            <Clock className="h-4 w-4" />
            <span className="text-xs">Waiting for upload...</span>
          </div>
        )}

        {status === 'processing' && (
          <div className="flex items-center gap-2">
            <Loader2 className="h-4 w-4 animate-spin text-amber-500" />
            <span className="text-xs text-amber-600 dark:text-amber-400 font-medium">
              Processing...
            </span>
          </div>
        )}

        {status === 'complete' && (
          <div className="flex items-center gap-2">
            <CheckCircle className="h-4 w-4 text-green-500" />
            <span className="text-xs text-green-600 dark:text-green-400 font-medium">
              Complete
            </span>
          </div>
        )}
      </div>

      <Handle type="target" position={Position.Left} className="!bg-muted-foreground" />
      <Handle type="source" position={Position.Right} className="!bg-muted-foreground" />
    </div>
  );
};
